module.exports = __webpack_public_path__ + "img/pc_nologin_banner.e7abe76.png";